import { jsxs as t, jsx as o } from "react/jsx-runtime";
const r = ({ className: C }) => /* @__PURE__ */ t(
  "svg",
  {
    width: "41",
    height: "41",
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: C,
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M26.4376 22.3333H24.8557C24.2236 22.3333 23.9075 22.3333 23.6582 22.439C22.8091 22.799 22.8207 23.6454 22.8207 24.4166C22.8207 25.1878 22.8091 26.0342 23.6582 26.3942C23.9075 26.4999 24.2236 26.4999 24.8557 26.4999C25.4879 26.4999 25.8039 26.4999 26.0533 26.6056C26.9023 26.9657 26.8908 27.812 26.8908 28.5833C26.8908 29.3545 26.9023 30.2008 26.0533 30.5609C25.8039 30.6666 25.4879 30.6666 24.8557 30.6666H23.1328M13.668 22.3333L16.5145 26.4999M16.5145 26.4999L19.361 30.6666M16.5145 26.4999L19.361 22.3333M16.5145 26.4999L13.668 30.6666M35.3346 30.6666H33.9114C32.5695 30.6666 31.8986 30.6666 31.4817 30.2598C31.0649 29.853 31.0649 29.1983 31.0649 27.8888V22.3333",
          stroke: "#13AE5C",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M25.3346 37.3333H18.2134C12.7781 37.3333 10.0604 37.3333 8.17309 36.0035C7.63234 35.6225 7.15227 35.1707 6.74747 34.6618C5.33464 32.8855 5.33464 30.3277 5.33464 25.212V20.9696C5.33464 16.031 5.33464 13.5617 6.1162 11.5895C7.37266 8.41895 10.0299 5.91806 13.3986 4.73551C15.494 3.99992 18.1177 3.99992 23.3649 3.99992C26.3634 3.99992 27.8626 3.99992 29.06 4.42025C30.985 5.096 32.5034 6.52508 33.2214 8.33682C33.668 9.46378 33.668 10.8748 33.668 13.6969V17.3333",
          stroke: "#13AE5C",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M5.33333 20.6666C5.33333 17.5984 7.82064 15.1111 10.8889 15.1111C11.9985 15.1111 13.3067 15.3055 14.3856 15.0164C15.3442 14.7596 16.0929 14.0108 16.3498 13.0522C16.6389 11.9734 16.4444 10.6652 16.4444 9.55551C16.4444 6.48727 18.9318 3.99996 22 3.99996",
          stroke: "#13AE5C",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
export {
  r as XslFileIcon
};
